var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenConsumption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 18.1875C12.3709 18.1875 13.0863 18.4838 13.6137 19.0113C14.1412 19.5387 14.4375 20.2541 14.4375 21C14.4375 21.7459 14.1412 22.4613 13.6137 22.9887C13.0863 23.5162 12.3709 23.8125 11.625 23.8125V25.6875C11.625 26.1848 11.8225 26.6617 12.1742 27.0133C12.5258 27.365 13.0027 27.5625 13.5 27.5625H28.5C28.9973 27.5625 29.4742 27.365 29.8258 27.0133C30.1775 26.6617 30.375 26.1848 30.375 25.6875V23.8125C29.6291 23.8125 28.9137 23.5162 28.3863 22.9887C27.8588 22.4613 27.5625 21.7459 27.5625 21C27.5625 20.2541 27.8588 19.5387 28.3863 19.0113C28.9137 18.4838 29.6291 18.1875 30.375 18.1875V16.3125C30.375 15.8152 30.1775 15.3383 29.8258 14.9867C29.4742 14.635 28.9973 14.4375 28.5 14.4375H13.5C13.0027 14.4375 12.5258 14.635 12.1742 14.9867C11.8225 15.3383 11.625 15.8152 11.625 16.3125V18.1875Z",
    stroke: "#0094FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 23.3438L23.3438 18.6562",
    stroke: "#0094FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenConsumption);
export default __webpack_public_path__ + "static/media/TokenConsumption.d3164dd55742c2a1a256dab0f8fe5da2.svg";
export { ForwardRef as ReactComponent };